module.exports = __webpack_public_path__ + "static/media/StacklineInterview.39177a37.PNG";